import React, { Component } from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom'
import App from './containers/App';
import Login from './containers/Login';
import ForgotPassword from './containers/ForgotPassword';
import ResetPassword from './containers/ResetPassword';
import GetToken from './containers/GetToken';
import OK from './OK';
import PrivateRoute from './utils/PrivateRoute';
import IndexRedirect from './utils/IndexRedirect';

// Root Component
class Root extends Component {
  render() {
    return(
      <BrowserRouter>
        <div>
          <Switch>
            <Route path="/" exact component={IndexRedirect} />
            <Route path="/getoken" component={GetToken} exact/>
            <Route path="/login" component={Login} exact/>
            <Route path="/forgotpassword" component={ForgotPassword} exact/>
            <Route path="/resetpassword" component={ResetPassword} exact/>
            <Route path="/ok" component={OK} exact/>
            <PrivateRoute path="/app" component={App} />
            <Redirect to="/login" />
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}
export default Root;



// WEBPACK FOOTER //
// ./src/Root.js